export const focusDay = (state) => state.focusDay
export const services = (state) => state.services
export const appointments = (state) => state.appointments
export const customers = (state) => state.customers
export const todayAppointments = (state) => state.todayAppointments
export const disabledSchedule = (state) => state.disabled
export const currentAppointment = (state) => state.currentAppointment

